import { index } from 'd3';
import React, { useContext } from 'react';
import { IconContext } from 'react-icons';

import { ColorContext, LayoutSizeContext } from 'App';

export default function ForecastSpread({
  style,
  header,
  data,
  icon,
  gap,
  dataIcons,
  headerStyle,
  headerClassName,
  dataItemStyle,
  dataItemClassName,
  dataRowStyle,
  dataRowClassName,
}) {
  const layout = useContext(LayoutSizeContext);

  const theme = useContext(ColorContext);

  const columns = Math.ceil(Math.sqrt(Object.keys(data).length));

  return (
    <div
      className="flex-column"
      style={{
        ...style,
      }}
    >
      <div className="flex-row align-items-center justify-space-between w-100 border-bottom border-light">
        <div
          className={headerClassName ?? 'fw-bold fs-1 w-100'}
          style={{
            ...headerStyle,
          }}
        >
          {header}
        </div>
        {icon && (
          <IconContext.Provider value={{ color: theme.fontColor, size: 25 }}>
            <div>{icon}</div>
          </IconContext.Provider>
        )}
      </div>

      {data && (
        <div className={dataRowClassName ?? `row row-cols-${columns}`} style={dataRowStyle}>
          {Object.keys(data).map((item, index) => {
            return (
              <div
                key={index}
                className={dataItemClassName ?? 'd-flex align-items-center fs-7 col'}
                style={dataItemStyle}
              >
                {dataIcons && dataIcons[index]}{' '}
                {item !== '' ? `${item}: ${data[item]}` : `${data[item]}`}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
